const Attraction = ({
  className = "",
  color,
}: {
  className?: string;
  color: string;
}): JSX.Element => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    role="img"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      data-name="layer3"
      d="M26 50v8.811A3.2 3.2 0 0 0 29.2 62h5.6a3.2 3.2 0 0 0 3.2-3.191V50z"
      fill="#de9372"
    ></path>
    <path
      data-name="layer2"
      d="M32 2c7.424 0 15.377 18.063 1.555 48H34v-.055c2.453-2 11.014-9.374 15.381-18.161A19.914 19.914 0 0 0 32 2zm0 0a19.972 19.972 0 0 0-20 19.941 19.772 19.772 0 0 0 2.621 9.841C18.988 40.574 27.559 47.95 30 49.947V50h.445C16.625 20.065 24.578 2 32 2z"
      fill={color}
    ></path>
    <path
      data-name="layer1"
      d="M30.449 50h3.105C47.377 20.063 39.424 2 32 2s-15.375 18.065-1.551 48z"
      fill={color}
    ></path>
    <path
      data-name="opacity"
      d="M31.878 2.006a19.9 19.9 0 0 0-17.257 29.776C18.988 40.574 27.559 47.95 30 49.947V50h-4v8.811A3.2 3.2 0 0 0 29.2 62h2.675z"
      fill="#000064"
      opacity=".15"
    ></path>
  </svg>
);

export default Attraction;
